module.exports = __webpack_public_path__ + "img/line1.b38a5ffa.png";